import { SupplyTransferStatusName } from '@caresend/types';
import { getShipmentPath, getSupplyTransferPath, hasStatus } from '@caresend/utils';
import { unwrapMaybeEncryptedData } from '../../../database/encryption/decrypt.js';
import 'js-sha256';
import '../../../database/firebaseConfig/cloudFunctions.js';
import '@sentry/vue';
import { toastError } from '../../../functions/toast/toast.js';
import '../../../database/encryption/model.js';
import 'firebase/auth';
import '../../../database/firebaseConfig/init.js';
import { dbSet, dbGroupSet } from '../../../database/firebaseConfig/methods.js';
import '@fortawesome/fontawesome-svg-core';
import 'buefy';
import '../../../components/ui/Icon.vue.js';
import '../../../functions/configuration/icons.js';
import '../../../database/algoliaConfig/indices.js';
import 'mobile-device-detect';
import '../../../functions/tracking/index.js';
import '../../../router/helpers/initRouter.js';
import '@firebase/auth';
import 'browser-image-compression';
import 'firebase/storage';

/**
 * The packer must be assigned to the supply transfer before they can read
 * the full procedures associated with the supply transfer
 * (security rules based on Procedure.supplyTransferID)
 *
 * - Assigns the packer if no packer assigned.
 * - Updates the status to in progress if the status is created.
 * - Throws an error if a different packer is already assigned.
 */
const maybeAssignPackerToSupplyShipment = async (supplyShipment, packerID) => {
    const currentPackerAlreadyAssigned = supplyShipment.packerID === packerID;
    const somePackerAssigned = !!supplyShipment.packerID;
    if (!currentPackerAlreadyAssigned && somePackerAssigned) {
        throw toastError(`Supply transfer ${supplyShipment.id} already assigned to another packer.`);
    }
    if (currentPackerAlreadyAssigned)
        return;
    await dbSet(getShipmentPath(supplyShipment.id, 'packerID'), packerID);
};
/**
 * The packer must be assigned to the supply transfer before they can read
 * the full procedures associated with the supply transfer
 * (security rules based on Procedure.supplyTransferID)
 *
 * - Assigns the packer if no packer assigned.
 * - Updates the status to in progress if the status is created.
 * - Throws an error if a different packer is already assigned.
 */
const maybeAssignPackerToSupplyTransfer = async (supplyTransfer, packerID) => {
    const currentPackerAlreadyAssigned = supplyTransfer.packerID === packerID;
    const somePackerAssigned = !!supplyTransfer.packerID;
    if (!currentPackerAlreadyAssigned && somePackerAssigned) {
        throw toastError(`Supply transfer ${supplyTransfer.id} already assigned to another packer.`);
    }
    if (currentPackerAlreadyAssigned)
        return;
    const updates = {};
    // Assign the packer
    updates[getSupplyTransferPath(supplyTransfer.id, 'packerID')] = packerID;
    // Maybe update the status
    if (hasStatus(supplyTransfer.status, SupplyTransferStatusName.ASSIGNED)) {
        const newStatus = {
            status: SupplyTransferStatusName.IN_PROGRESS,
            timestamp: Date.now(),
        };
        updates[getSupplyTransferPath(supplyTransfer.id, 'status')] = newStatus;
    }
    await dbGroupSet(updates);
};
const decryptShipment = async (encryptedShipment) => {
    const shipment = {
        ...encryptedShipment,
        shippingRecipient: await unwrapMaybeEncryptedData(encryptedShipment.shippingRecipient),
    };
    return shipment;
};

export { decryptShipment, maybeAssignPackerToSupplyShipment, maybeAssignPackerToSupplyTransfer };
